<script lang="ts">
  // Avg (filled bar) / Max (tick) / Current (live hover dot) gauge shared by Power, Speed,
  // Cadence, and Heart Rate. Power plots on a log scale to keep low/mid-range differences
  // visible instead of them getting squeezed left by a handful of high-power spikes; the
  // others are linear. Power also renders avg/max in a neutral grey ("muted" tone) rather
  // than its own color -- everyone else colors avg/max the same as the current dot.
  export let avg: number | null = null;
  export let max: number | null = null;
  export let current: number | null = null;
  export let color: string;
  export let scale: 'linear' | 'log' = 'linear';
  export let tone: 'colored' | 'muted' = 'colored';

  $: gaugeScale = Math.max(max ?? 0, current ?? 0);
  const linearPct = (value: number, scaleMax: number) => (scaleMax > 0 ? Math.min(100, (value / scaleMax) * 100) : 0);
  const logPct = (value: number, scaleMax: number) => (scaleMax > 0 ? Math.min(100, (Math.log(value + 1) / Math.log(scaleMax + 1)) * 100) : 0);
  $: pct = scale === 'log' ? logPct : linearPct;
  $: avgPct = gaugeScale > 0 && avg != null ? pct(avg, gaugeScale) : null;
  $: maxPct = gaugeScale > 0 && max != null ? pct(max, gaugeScale) : null;
  $: currentPct = gaugeScale > 0 && current != null ? pct(current, gaugeScale) : null;
</script>

{#if gaugeScale > 0}
  <div class="relative h-2 w-full rounded-full bg-muted">
    {#if avgPct != null}
      {#if tone === 'muted'}
        <div class="absolute inset-y-0 left-0 rounded-full bg-muted-foreground/30" style="width: {avgPct}%" />
      {:else}
        <div class="absolute inset-y-0 left-0 rounded-full" style="width: {avgPct}%; background-color: {color}; opacity: 0.35" />
      {/if}
    {/if}
    {#if maxPct != null}
      {#if tone === 'muted'}
        <div class="absolute top-0 h-full w-0.5 bg-muted-foreground/50" style="left: {maxPct}%" />
      {:else}
        <div class="absolute top-0 h-full w-0.5" style="left: {maxPct}%; background-color: {color}; opacity: 0.7" />
      {/if}
    {/if}
    {#if currentPct != null}
      <div
        class="absolute top-1/2 h-3 w-3 -translate-y-1/2 -translate-x-1/2 rounded-full ring-2 ring-background"
        style="left: {currentPct}%; background-color: {color}"
      />
    {/if}
  </div>
{/if}
